// 2025 Topps Star Wars Hyperspace
// Structure source-verified against Cardboard Connection, Beckett and Checklist
// Insider, plus eBay specimens (base Nebulae vs Blue Lazer split, Aqua Sonar /199,
// autograph Hyperlanes /25, Planetary Views /99). Card names seeded from the
// production DB (set_id 0dff747f-a8e5-419a-8dc6-b28981783ab1).
// Sketch Cards and Oversized Panoramic Sketch Cards are intentionally omitted:
// they are 1/1 original art with no card-level checklist in the DB or any source.

// Base parallel ladder. Nebulae (unnumbered) and Blue Lazer (/150) are distinct
// parallels (DB had conflated them). Aqua Sonar /199 is a retail parallel confirmed
// by two eBay specimens (R2-D2 #22, Fambaas #73); not on the hobby checklist sources.
const BASE_PARALLELS = [
  { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
  { id: 'nebulae', name: 'Nebulae Refractor', print_run: null, color: '#c9b6ff' },
  { id: 'aqua-sonar', name: 'Aqua Sonar Refractor', print_run: 199, color: '#00e5ff' },
  { id: 'blue-lazer', name: 'Blue Lazer Refractor', print_run: 150, color: '#4d9fff' },
  { id: 'pulsar', name: 'Pulsar Refractor', print_run: 99, color: '#29b6f6' },
  { id: 'galactic-dust', name: 'Galactic Dust Refractor', print_run: 75, color: '#d4a855' },
  { id: 'gold-galactic-dust', name: 'Gold Galactic Dust Refractor', print_run: 50, color: '#f0c040' },
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 25, color: '#ff9100' },
  { id: 'black-hyperlanes', name: 'Black Hyperlanes Refractor', print_run: 10, color: '#b0b0b0' },
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Base Planetary Variations are themselves serial /99 SPs (confirmed by a BPV eBay
// specimen labelled plain "/99"). Single unnamed slot -> the UI renders just "/99".
const PLANETARY_VARIATION_PARALLELS = [
  { id: 'sp', name: '', print_run: 99, color: '#c8d8f0' },
];

// Shared 7-step insert ladder (Moon of Mandalore, There's Always a Bigger Fish,
// Galactic Eras).
const INSERT_7 = [
  { id: 'pulsar', name: 'Pulsar Refractor', print_run: 99, color: '#29b6f6' },
  { id: 'galactic-dust', name: 'Galactic Dust Refractor', print_run: 75, color: '#d4a855' },
  { id: 'gold-galactic-dust', name: 'Gold Galactic Dust Refractor', print_run: 50, color: '#f0c040' },
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 25, color: '#ff9100' },
  { id: 'black-hyperlanes', name: 'Black Hyperlanes Refractor', print_run: 10, color: '#b0b0b0' },
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Art of Tatooine / Galactic Origins use the Shimmer + RayWave ladder.
const ART_PARALLELS = [
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 25, color: '#ff9100' },
  { id: 'shimmer', name: 'Shimmer Refractor', print_run: 10, color: '#b2ebf2' },
  { id: 'raywave', name: 'RayWave Refractor', print_run: 5, color: '#ff4081' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

const REFLECTIONS_PARALLELS = [
  { id: 'kaleidoscope', name: 'Kaleidoscope Refractor', print_run: 25, color: '#e040fb' },
  { id: 'shimmer', name: 'Shimmer Refractor', print_run: 10, color: '#b2ebf2' },
  { id: 'raywave', name: 'RayWave Refractor', print_run: 5, color: '#ff4081' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Planetary Views: 7-step but Shimmer/RayWave replace Black/Red Hyperlanes.
const PLANETARY_VIEWS_PARALLELS = [
  { id: 'pulsar', name: 'Pulsar Refractor', print_run: 99, color: '#29b6f6' },
  { id: 'galactic-dust', name: 'Galactic Dust Refractor', print_run: 75, color: '#d4a855' },
  { id: 'gold-galactic-dust', name: 'Gold Galactic Dust Refractor', print_run: 50, color: '#f0c040' },
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 25, color: '#ff9100' },
  { id: 'shimmer', name: 'Shimmer Refractor', print_run: 10, color: '#b2ebf2' },
  { id: 'raywave', name: 'RayWave Refractor', print_run: 5, color: '#ff4081' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

const GALACTIC_ORIGINS_PARALLELS = [
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 25, color: '#ff9100' },
  { id: 'raywave', name: 'RayWave Refractor', print_run: 5, color: '#ff4081' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

const SHADOWBOX_PARALLELS = [
  { id: 'black-hyperlanes', name: 'Black Hyperlanes Refractor', print_run: 10, color: '#b0b0b0' },
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

// Autograph parallels. Base autograph is unnumbered/on-card (no serialized base, so
// no serial slot needed). Hyperlanes /25 confirmed by eBay specimen (Cardboard
// Connection's "/75" was a source error).
const AUTO_PARALLELS_LADDER = [
  { id: 'pulsar', name: 'Pulsar Refractor', print_run: 99, color: '#29b6f6' },
  { id: 'gold-galactic-dust', name: 'Gold Galactic Dust Refractor', print_run: 50, color: '#f0c040' },
  { id: 'hyperlanes', name: 'Hyperlanes Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red-hyperlanes', name: 'Red Hyperlanes Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];

export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE CARDS — 100 CARDS', parallels: BASE_PARALLELS,
    cards: [
      {n:'1', name:'Ahsoka Tano'},
      {n:'2', name:'Alderaan Royal Guard'},
      {n:'3', name:'Aurra Sing'},
      {n:'4', name:'Bail Organa'},
      {n:'5', name:'Breha Organa'},
      {n:'6', name:'Captain Typho'},
      {n:'7', name:'Celly Organa'},
      {n:'8', name:'Kayo Organa'},
      {n:'9', name:'L0-LA59'},
      {n:'10', name:'Leia Organa'},
      {n:'11', name:'Mon Mothma'},
      {n:'12', name:'Naboo Royal Cruiser'},
      {n:'13', name:'Niano Organa'},
      {n:'14', name:'Tantive IV'},
      {n:'15', name:'Vect Nokru'},
      {n:'16', name:'Ahsoka Tano'},
      {n:'17', name:'Chopper'},
      {n:'18', name:'Han Solo'},
      {n:'19', name:"Han Solo's landspeeder"},
      {n:'20', name:'Hera Syndulla'},
      {n:'21', name:'HK-87 Assassin Droid'},
      {n:'22', name:'Marrok'},
      {n:'23', name:"Qi'ra"},
      {n:'24', name:'Stormtrooper'},
      {n:'25', name:'Agent Kallus'},
      {n:'26', name:'Darth Vader'},
      {n:'27', name:'Ezra Bridger'},
      {n:'28', name:'Fifth Brother'},
      {n:'29', name:'Garazeb Orrelios'},
      {n:'30', name:'Governor Pryce'},
      {n:'31', name:'Grand Admiral Thrawn'},
      {n:'32', name:'Huyang'},
      {n:'33', name:'Kanan Jarrus'},
      {n:'34', name:'Loth-cat'},
      {n:'35', name:'Loth-wolf'},
      {n:'36', name:'Rukh'},
      {n:'37', name:'Ryder Azadi'},
      {n:'38', name:'Sabine Wren'},
      {n:'39', name:'Seventh Sister'},
      {n:'40', name:'Shin Hati'},
      {n:'41', name:'The Grand Inquisitor'},
      {n:'42', name:'Tie Fighter'},
      {n:'43', name:'Almec'},
      {n:'44', name:'Amis'},
      {n:'45', name:'Anakin Skywalker'},
      {n:'46', name:'Bo-Katan Kryze'},
      {n:'47', name:"Bo-Katan Kryze's Gauntlet starfighter"},
      {n:'48', name:'Duchess Satine Kryze'},
      {n:'49', name:'Imperial Armored Commando'},
      {n:'50', name:'Korkie Kryze'},
      {n:'51', name:'Koska Reeves'},
      {n:'52', name:'Moff Gideon'},
      {n:'53', name:'Paz Vizsla'},
      {n:'54', name:'Pre Vizsla'},
      {n:'55', name:'R5-D4'},
      {n:'56', name:'Soniee'},
      {n:'57', name:'The Armorer'},
      {n:'58', name:'The Coronet'},
      {n:'59', name:'The Mandalorian'},
      {n:'60', name:'Ursa Wren'},
      {n:'61', name:"Anakin Skywalker's Podracer"},
      {n:'62', name:'Bib Fortuna'},
      {n:'63', name:'Boba Fett'},
      {n:'64', name:"Boba Fett's Starship"},
      {n:'65', name:'C-3PO'},
      {n:'66', name:'Cad Bane'},
      {n:'67', name:'Chef Droid'},
      {n:'68', name:'Cobb Vanth'},
      {n:'69', name:'Darth Maul'},
      {n:'70', name:'Desert Skiff'},
      {n:'71', name:'Fennec Shand'},
      {n:'72', name:"Figrin D'an"},
      {n:'73', name:'Gamorrean Guard'},
      {n:'74', name:'Garsa Fwip'},
      {n:'75', name:'Grogu'},
      {n:'76', name:'Jabba The Hutt'},
      {n:'77', name:'Jar Jar Binks'},
      {n:'78', name:'Jawa'},
      {n:'79', name:'Krrsantan'},
      {n:'80', name:'Luke Skywalker'},
      {n:'81', name:'Max Rebo'},
      {n:'82', name:'Millennium Falcon'},
      {n:'83', name:'Naboo N-1 Starfighter'},
      {n:'84', name:'Obi-Wan Kenobi'},
      {n:'85', name:'Owen Lars'},
      {n:'86', name:'Padmé Amidala'},
      {n:'87', name:'Peli Motto'},
      {n:'88', name:'Qui-Gon Jinn'},
      {n:'89', name:'R2-D2'},
      {n:'90', name:'Rancor'},
      {n:'91', name:'Rancor Keeper'},
      {n:'92', name:'Razor Crest'},
      {n:'93', name:'Rey Skywalker'},
      {n:'94', name:'Salacious B. Crumb'},
      {n:'95', name:'Sandcrawler'},
      {n:'96', name:'Sebulba'},
      {n:'97', name:'Skad'},
      {n:'98', name:'Tusken Raider'},
      {n:'99', name:'Watto'},
      {n:'100', name:'X-34 Landspeeder'},
    ]
  },
  {
    id: 'base-planetary-variations', type: 'base', title: 'BASE CARDS PLANETARY VARIATIONS — 100 CARDS', parallels: PLANETARY_VARIATION_PARALLELS,
    cards: [
      {n:'BPV-1', name:'Ahsoka Tano'},
      {n:'BPV-2', name:'Alderaan Royal Guard'},
      {n:'BPV-3', name:'Aurra Sing'},
      {n:'BPV-4', name:'Bail Organa'},
      {n:'BPV-5', name:'Breha Organa'},
      {n:'BPV-6', name:'Captain Typho'},
      {n:'BPV-7', name:'Celly Organa'},
      {n:'BPV-8', name:'Kayo Organa'},
      {n:'BPV-9', name:'L0-LA59'},
      {n:'BPV-10', name:'Leia Organa'},
      {n:'BPV-11', name:'Mon Mothma'},
      {n:'BPV-12', name:'Naboo Royal Cruiser'},
      {n:'BPV-13', name:'Niano Organa'},
      {n:'BPV-14', name:'Tantive IV'},
      {n:'BPV-15', name:'Vect Nokru'},
      {n:'BPV-16', name:'Ahsoka Tano'},
      {n:'BPV-17', name:'Chopper'},
      {n:'BPV-18', name:'Han Solo'},
      {n:'BPV-19', name:"Han Solo's landspeeder"},
      {n:'BPV-20', name:'Hera Syndulla'},
      {n:'BPV-21', name:'HK-87 Assassin Droid'},
      {n:'BPV-22', name:'Marrok'},
      {n:'BPV-23', name:"Qi'ra"},
      {n:'BPV-24', name:'Stormtrooper'},
      {n:'BPV-25', name:'Agent Kallus'},
      {n:'BPV-26', name:'Darth Vader'},
      {n:'BPV-27', name:'Ezra Bridger'},
      {n:'BPV-28', name:'Fifth Brother'},
      {n:'BPV-29', name:'Garazeb Orrelios'},
      {n:'BPV-30', name:'Governor Pryce'},
      {n:'BPV-31', name:'Grand Admiral Thrawn'},
      {n:'BPV-32', name:'Huyang'},
      {n:'BPV-33', name:'Kanan Jarrus'},
      {n:'BPV-34', name:'Loth-cat'},
      {n:'BPV-35', name:'Loth-wolf'},
      {n:'BPV-36', name:'Rukh'},
      {n:'BPV-37', name:'Ryder Azadi'},
      {n:'BPV-38', name:'Sabine Wren'},
      {n:'BPV-39', name:'Seventh Sister'},
      {n:'BPV-40', name:'Shin Hati'},
      {n:'BPV-41', name:'The Grand Inquisitor'},
      {n:'BPV-42', name:'Tie Fighter'},
      {n:'BPV-43', name:'Almec'},
      {n:'BPV-44', name:'Amis'},
      {n:'BPV-45', name:'Anakin Skywalker'},
      {n:'BPV-46', name:'Bo-Katan Kryze'},
      {n:'BPV-47', name:"Bo-Katan Kryze's Gauntlet starfighter"},
      {n:'BPV-48', name:'Duchess Satine Kryze'},
      {n:'BPV-49', name:'Imperial Armored Commando'},
      {n:'BPV-50', name:'Korkie Kryze'},
      {n:'BPV-51', name:'Koska Reeves'},
      {n:'BPV-52', name:'Moff Gideon'},
      {n:'BPV-53', name:'Paz Vizsla'},
      {n:'BPV-54', name:'Pre Vizsla'},
      {n:'BPV-55', name:'R5-D4'},
      {n:'BPV-56', name:'Soniee'},
      {n:'BPV-57', name:'The Armorer'},
      {n:'BPV-58', name:'The Coronet'},
      {n:'BPV-59', name:'The Mandalorian'},
      {n:'BPV-60', name:'Ursa Wren'},
      {n:'BPV-61', name:"Anakin Skywalker's Podracer"},
      {n:'BPV-62', name:'Bib Fortuna'},
      {n:'BPV-63', name:'Boba Fett'},
      {n:'BPV-64', name:"Boba Fett's Starship"},
      {n:'BPV-65', name:'C-3PO'},
      {n:'BPV-66', name:'Cad Bane'},
      {n:'BPV-67', name:'Chef Droid'},
      {n:'BPV-68', name:'Cobb Vanth'},
      {n:'BPV-69', name:'Darth Maul'},
      {n:'BPV-70', name:'Desert Skiff'},
      {n:'BPV-71', name:'Fennec Shand'},
      {n:'BPV-72', name:"Figrin D'an"},
      {n:'BPV-73', name:'Gamorrean Guard'},
      {n:'BPV-74', name:'Garsa Fwip'},
      {n:'BPV-75', name:'Grogu'},
      {n:'BPV-76', name:'Jabba The Hutt'},
      {n:'BPV-77', name:'Jar Jar Binks'},
      {n:'BPV-78', name:'Jawa'},
      {n:'BPV-79', name:'Krrsantan'},
      {n:'BPV-80', name:'Luke Skywalker'},
      {n:'BPV-81', name:'Max Rebo'},
      {n:'BPV-82', name:'Millennium Falcon'},
      {n:'BPV-83', name:'Naboo N-1 Starfighter'},
      {n:'BPV-84', name:'Obi-Wan Kenobi'},
      {n:'BPV-85', name:'Owen Lars'},
      {n:'BPV-86', name:'Padmé Amidala'},
      {n:'BPV-87', name:'Peli Motto'},
      {n:'BPV-88', name:'Qui-Gon Jinn'},
      {n:'BPV-89', name:'R2-D2'},
      {n:'BPV-90', name:'Rancor'},
      {n:'BPV-91', name:'Rancor Keeper'},
      {n:'BPV-92', name:'Razor Crest'},
      {n:'BPV-93', name:'Rey Skywalker'},
      {n:'BPV-94', name:'Salacious B. Crumb'},
      {n:'BPV-95', name:'Sandcrawler'},
      {n:'BPV-96', name:'Sebulba'},
      {n:'BPV-97', name:'Skad'},
      {n:'BPV-98', name:'Tusken Raider'},
      {n:'BPV-99', name:'Watto'},
      {n:'BPV-100', name:'X-34 Landspeeder'},
    ]
  },
  {
    id: 'moon-of-mandalore', type: 'insert', title: 'MOON OF MANDALORE — 10 CARDS', parallels: INSERT_7,
    cards: [
      {n:'MOM-1', name:'Obi-Wan Kenobi'},
      {n:'MOM-2', name:'Duchess Satine Kryze'},
      {n:'MOM-3', name:'Pre Vizsla'},
      {n:'MOM-4', name:'Mandalorian Guard'},
      {n:'MOM-5', name:'Death Watch Warrior'},
      {n:'MOM-6', name:'Gauntlet Fighter'},
      {n:'MOM-7', name:'Bo-Katan Kryze'},
      {n:'MOM-8', name:'Prime Minister Almec'},
      {n:'MOM-9', name:'Count Dooku'},
      {n:'MOM-10', name:"Obi-Wan's Delta-7 Jedi Starfighter"},
    ]
  },
  {
    id: 'theres-always-a-bigger-fish', type: 'insert', title: "THERE'S ALWAYS A BIGGER FISH — 15 CARDS", parallels: INSERT_7,
    cards: [
      {n:'BIG-1', name:'Loth-cat'},
      {n:'BIG-2', name:'Bantha'},
      {n:'BIG-3', name:'Purrgil'},
      {n:'BIG-4', name:'Sarlacc'},
      {n:'BIG-5', name:'Krayt Dragon'},
      {n:'BIG-6', name:'Corellian hound'},
      {n:'BIG-7', name:'Mythosaur'},
      {n:'BIG-8', name:'Rancor'},
      {n:'BIG-9', name:'Puffer Pig'},
      {n:'BIG-10', name:'Loth-wolf'},
      {n:'BIG-11', name:'Dewback'},
      {n:'BIG-12', name:'Alamite'},
      {n:'BIG-13', name:'Sand Beast'},
      {n:'BIG-14', name:"B'omarr monk spider"},
      {n:'BIG-15', name:'Worrt'},
    ]
  },
  {
    id: 'galactic-eras', type: 'insert', title: 'GALACTIC ERAS — 25 CARDS', parallels: INSERT_7,
    cards: [
      {n:'ERA-1', name:'Leia Organa Is Kidnapped By Vect Nokru'},
      {n:'ERA-2', name:'Han Solo Is Rescued'},
      {n:'ERA-3', name:'A More Civilized Weapon'},
      {n:'ERA-4', name:'"These Aren\'t The Droids You\'re Looking For"'},
      {n:'ERA-5', name:'The Purrgil Rescue Ezra Bridger'},
      {n:'ERA-6', name:'Bo-Katan Kryze Unites Mandalore'},
      {n:'ERA-7', name:'Battle Over The Sarlacc Pit'},
      {n:'ERA-8', name:'Boba Fett Rides His New Rancor'},
      {n:'ERA-9', name:'The Mandalorian, The Marshal, and The Krayt Dragon'},
      {n:'ERA-10', name:"Duchess Satine Kryze's Demise"},
      {n:'ERA-11', name:'Ahsoka Duels Maul At The Siege Of Mandalore'},
      {n:'ERA-12', name:'Ezra Bridger Rides The Loth-wolf'},
      {n:'ERA-13', name:"Sabine Wren Skips Ryder Azadi's Speech"},
      {n:'ERA-14', name:'Shin Hati Attacks Sabine Wren'},
      {n:'ERA-15', name:"Ahsoka Tano's Apprentice, Again"},
      {n:'ERA-16', name:'Ahsoka vs Marrok'},
      {n:'ERA-17', name:"Han Solo And Qi'ra, Separated!"},
      {n:'ERA-18', name:'Qui-Gon Jinn vs Darth Maul'},
      {n:'ERA-19', name:'The Chase For Han Solo'},
      {n:'ERA-20', name:'The Mandalorian vs Moff Gideon'},
      {n:'ERA-21', name:'Destroyed By The Death Star!'},
      {n:'ERA-22', name:'Obi-Wan Kenobi vs Maul'},
      {n:'ERA-23', name:'Anakin Skywalker Wins the Boonta Eve Classic'},
      {n:'ERA-24', name:'Obi-Wan Kenobi Brings Leia Organa Home'},
      {n:'ERA-25', name:'The Great Purge of Mandalore'},
    ]
  },
  {
    id: 'art-of-tatooine', type: 'insert', title: 'ART OF TATOOINE — 15 CARDS', parallels: ART_PARALLELS,
    cards: [
      {n:'AOT-1', name:'Mos Eisley', artist:'Steve Hamilton'},
      {n:'AOT-2', name:"Ben Kenobi's Hut", artist:'Steve Hamilton'},
      {n:'AOT-3', name:'Dune Sea', artist:'Steve Hamilton'},
      {n:'AOT-4', name:"Beggar's Canyon", artist:'Steve Hamilton'},
      {n:'AOT-5', name:'Mos Espa', artist:'Steve Hamilton'},
      {n:'AOT-6', name:'Mos Espa Grand Arena', artist:'Steve Hamilton'},
      {n:'AOT-7', name:'Tibidon Carving Station', artist:'Steve Hamilton'},
      {n:'AOT-8', name:'Freetown', artist:'Steve Hamilton'},
      {n:'AOT-9', name:'The Jundland Wastes', artist:'Steve Hamilton'},
      {n:'AOT-10', name:"Jabba's Palace", artist:'Steve Hamilton'},
      {n:'AOT-11', name:'The Lars Homestead', artist:'Steve Hamilton'},
      {n:'AOT-12', name:'Sarlacc Pit', artist:'Steve Hamilton'},
      {n:'AOT-13', name:'Pyke Base', artist:'Steve Hamilton'},
      {n:'AOT-14', name:"Garsa's Sanctuary", artist:'Steve Hamilton'},
      {n:'AOT-15', name:'Mos Eisley Cantina', artist:'Steve Hamilton'},
    ]
  },
  {
    id: 'star-wars-reflections', type: 'insert', title: 'STAR WARS REFLECTIONS — 5 CARDS', parallels: REFLECTIONS_PARALLELS,
    cards: [
      {n:'R-16', name:'The Empire', artist:'Christian Waggoner'},
      {n:'R-17', name:"The Armorer's Guidance", artist:'Christian Waggoner'},
      {n:'R-18', name:'Protecting Someone?', artist:'Christian Waggoner'},
      {n:'R-19', name:'I Thought You Were Dead', artist:'Christian Waggoner'},
      {n:'R-20', name:'Darth Vader', artist:'Christian Waggoner'},
    ]
  },
  {
    id: 'planetary-views', type: 'insert', title: 'PLANETARY VIEWS — 5 CARDS', parallels: PLANETARY_VIEWS_PARALLELS,
    cards: [
      {n:'PV-6', name:'Alderaan'},
      {n:'PV-7', name:'Lothal'},
      {n:'PV-8', name:'Mandalore'},
      {n:'PV-9', name:'Corellia'},
      {n:'PV-10', name:'Tatooine'},
    ]
  },
  {
    id: 'galactic-origins', type: 'insert', title: 'GALACTIC ORIGINS — 10 CARDS', parallels: GALACTIC_ORIGINS_PARALLELS,
    cards: [
      {n:'GO-1', name:'Leia Organa', artist:'Traci Easterday'},
      {n:'GO-2', name:'Han Solo', artist:'Traci Easterday'},
      {n:'GO-3', name:'Ahsoka Tano', artist:'Traci Easterday'},
      {n:'GO-4', name:'Shin Hati', artist:'Traci Easterday'},
      {n:'GO-5', name:'Sabine Wren', artist:'Traci Easterday'},
      {n:'GO-6', name:'The Mandalorian', artist:'Traci Easterday'},
      {n:'GO-7', name:'Moff Gideon', artist:'Traci Easterday'},
      {n:'GO-8', name:'Qui-Gon Jinn', artist:'Traci Easterday'},
      {n:'GO-9', name:'Luke Skywalker', artist:'Traci Easterday'},
      {n:'GO-10', name:'Boba Fett', artist:'Traci Easterday'},
    ]
  },
  {
    id: 'hyperspace-shadowbox', type: 'insert', title: 'HYPERSPACE SHADOWBOX — 20 CARDS', parallels: SHADOWBOX_PARALLELS,
    cards: [
      {n:'HYP-1', name:'C-3PO'},
      {n:'HYP-2', name:'R2-D2'},
      {n:'HYP-3', name:'Boba Fett'},
      {n:'HYP-4', name:'Cad Bane'},
      {n:'HYP-5', name:'Bail Organa'},
      {n:'HYP-6', name:'Grogu'},
      {n:'HYP-7', name:'Ahsoka Tano'},
      {n:'HYP-8', name:"Qi'ra"},
      {n:'HYP-9', name:'Salacious B. Crumb'},
      {n:'HYP-10', name:'Stormtrooper'},
      {n:'HYP-11', name:'Lady Proxima'},
      {n:'HYP-12', name:'Bo-Katan Kryze'},
      {n:'HYP-13', name:'Paz Vizsla'},
      {n:'HYP-14', name:'The Armorer'},
      {n:'HYP-15', name:'The Mandalorian'},
      {n:'HYP-16', name:'Breha Organa'},
      {n:'HYP-17', name:'Leia Organa'},
      {n:'HYP-18', name:'Huyang'},
      {n:'HYP-19', name:'Luke Skywalker'},
      {n:'HYP-20', name:'Darth Maul'},
    ]
  },
  {
    id: 'oversized-widevision-chrome', type: 'insert', title: 'OVERSIZED WIDEVISION CHROME — 5 CARDS', parallels: [],
    cards: [
      {n:'WIDE-1', name:'Alderaan Sector'},
      {n:'WIDE-2', name:'Lothal Sector'},
      {n:'WIDE-3', name:'Mandalore Sector'},
      {n:'WIDE-4', name:'Corellian Sector'},
      {n:'WIDE-5', name:'Arkanis Sector'},
    ]
  },
  {
    id: 'star-wars-autograph-variation', type: 'auto', title: 'STAR WARS AUTOGRAPH VARIATION — 37 CARDS', parallels: AUTO_PARALLELS_LADDER,
    cards: [
      {n:'AV-AHM', name:'Ahmed Best'},
      {n:'AV-ALD', name:'Alden Ehrenreich'},
      {n:'AV-ANT', name:'Anthony Daniels'},
      {n:'AV-ASH', name:'Ashley Eckstein'},
      {n:'AV-BDEE', name:'Billy Dee Williams'},
      {n:'AV-CAM', name:'Carrie-Anne Moss'},
      {n:'AV-DAI', name:'Daisy Ridley'},
      {n:'AV-DAW', name:'Rosario Dawson'},
      {n:'AV-EDG', name:'Joel Edgerton'},
      {n:'AV-EMC', name:'Emilia Clarke'},
      {n:'AV-EMG', name:'Ewan McGregor'},
      {n:'AV-EMS', name:'Emily Swallow'},
      {n:'AV-FOR', name:'Harrison Ford'},
      {n:'AV-GIA', name:'Giancarlo Esposito'},
      {n:'AV-HAM', name:'Mark Hamill'},
      {n:'AV-HC', name:'Hayden Christensen'},
      {n:'AV-IVA', name:'Ivanna Sakhno'},
      {n:'AV-JEN', name:'Jennifer Beals'},
      {n:'AV-KAT', name:'Katee Sackhoff'},
      {n:'AV-KK', name:'Keira Knightley'},
      {n:'AV-KYK', name:'Kyriana Kratter'},
      {n:'AV-LAW', name:'Jude Law'},
      {n:'AV-LIU', name:'Natasha Liu Bordizzo'},
      {n:'AV-LJJ', name:'Lee Jung-jae'},
      {n:'AV-MEW', name:'Mary Elizabeth Winstead'},
      {n:'AV-MIN', name:'Ming-Na Wen'},
      {n:'AV-MOS', name:'Moses Ingram'},
      {n:'AV-NAT', name:'Natalie Portman'},
      {n:'AV-OLY', name:'Timothy Olyphant'},
      {n:'AV-OSJ', name:"O'Shea Jackson Jr."},
      {n:'AV-PAS', name:'Pedro Pascal'},
      {n:'AV-RAY', name:'Ray Park'},
      {n:'AV-RTS', name:'Robert Timothy Smith'},
      {n:'AV-TEM', name:'Temuera Morrison'},
      {n:'AV-THU', name:'Thundercat'},
      {n:'AV-WAI', name:'Taika Waititi'},
      {n:'AV-WIT', name:'Sam Witwer'},
    ]
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

export const PARALLELS = BASE_PARALLELS;
export const AUTO_PARALLELS = AUTO_PARALLELS_LADDER;
export const INSERT_PARALLELS = INSERT_7;
